import React from "react";
import { motion } from "framer-motion";

const projects = [
  {
    name: "Skyline Towers Renovation",
    image: "https://images.unsplash.com/photo-1587919968590-fbc98cea6c9a?w=600&auto=format&fit=crop&q=60&ixlib=rb-4.0.3",
    description: "A complete transformation of Skyline Towers, enhancing its structural integrity and modernizing its facade."
  },
  {
    name: "Evergreen Commercial Complex",
    image: "https://images.unsplash.com/photo-1582280871722-424e91cbee8b?w=600&auto=format&fit=crop&q=60&ixlib=rb-4.0.3",
    description: "Designed and built a state-of-the-art commercial space with sustainability at its core."
  },
  {
    name: "Horizon Heights Apartments",
    image: "https://images.unsplash.com/photo-1600221574280-9bcd5d108100?w=600&auto=format&fit=crop&q=60&ixlib=rb-4.0.3",
    description: "Constructed high-rise luxury apartments with breathtaking views and modern amenities."
  },
  {
    name: "Riverside Bridge Expansion",
    image: "https://images.unsplash.com/photo-1609337231803-2adad48ea1d1?w=600&auto=format&fit=crop&q=60&ixlib=rb-4.0.3",
    description: "Engineered a durable and aesthetically pleasing bridge to improve urban connectivity."
  },
  {
    name: "Summit Business Park",
    image: "https://plus.unsplash.com/premium_photo-1678344170545-c3edef92a16e?w=600&auto=format&fit=crop&q=60&ixlib=rb-4.0.3",
    description: "Developed a cutting-edge business hub featuring modern office spaces and green spaces."
  },
  {
    name: "Heritage Museum Restoration",
    image: "https://images.unsplash.com/photo-1594402919317-9e67dca0a305?w=600&auto=format&fit=crop&q=60&ixlib=rb-4.0.3",
    description: "Preserved and revitalized a historical landmark while maintaining its cultural essence."
  },
];

const Homebody4 = () => {
  return (
    <div className="bg-[#F7F8F9] text-gray-900 py-10">
      {/* Header Section */}
      <motion.section
        initial={{ opacity: 0, y: 50 }}
        animate={{ opacity: 1, y: 0 }}
        transition={{ duration: 1 }}
        className="max-w-7xl mx-auto text-center px-6 py-12"
      >
        <h1 className="text-5xl font-bold text-[#29313F] mb-6">
          Our Work Speaks for Itself
        </h1>
        <p className="text-lg text-gray-600 mb-8">
          Discover how we bring ideas to life through expert craftsmanship, innovative engineering, and attention to detail.
        </p>
        <button className="bg-[#29313F] text-white py-3 px-6 rounded-xl shadow-lg hover:bg-[#29313F]  transition-all duration-300">
          View Our Projects
        </button>
      </motion.section>

      {/* Projects Grid Section */}
      <motion.section
        initial={{ opacity: 0, y: 50 }}
        animate={{ opacity: 1, y: 0 }}
        transition={{ duration: 1, delay: 0.2 }}
        className="max-w-7xl mx-auto grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-8 px-6 py-12"
      >
        {projects.map((project, index) => (
          <motion.div
            key={index}
            initial={{ opacity: 0 }}
            whileInView={{ opacity: 1 }}
            transition={{ duration: 0.8, delay: index * 0.2 }}
            viewport={{ once: true }}
            className="bg-white rounded-lg shadow-lg overflow-hidden transform transition-all hover:scale-105"
          >
            <img
              src={project.image}
              alt={`Image of ${project.name}`}
              className="w-full h-48 object-cover"
            />
            <div className="p-6">
              <h3 className="text-2xl font-semibold text-[#29313F] mb-4">
                {project.name}
              </h3>
              <p className="text-gray-600">
                {project.description}
              </p>
            </div>
          </motion.div>
        ))}
      </motion.section>

      {/* CTA Section */}
      <motion.section
        initial={{ opacity: 0, y: 50 }}
        animate={{ opacity: 1, y: 0 }}
        transition={{ duration: 1 }}
        className="bg-[#29313F] text-white py-12 px-6 text-center"
      >
        <h2 className="text-3xl font-semibold mb-4">Let’s Build Together</h2>
        <p className="text-lg mb-8">
          Ready to start your next construction project with us? Reach out, and let’s create something extraordinary.
        </p>
        <a href="/contactus">
          <button className="bg-white text-[#29313F] py-3 px-6 rounded-xl shadow-lg hover:bg-[#D1D5DB] hover:text-[#1D4ED8] transition-all duration-300">
            Contact Us
          </button>
        </a>
      </motion.section>
    </div>
  );
};

export default Homebody4;
